<div class="chrome-header k-shadow">
  <div id="ece-chrome-title" class="logo">
    <div class="chrome-header-title pull-left"></div>
    <span class="title">Circulation</span>
    <span *ngIf="stageMark?.show" [ngClass]="['stageMark', 'stage-'+stageMark.name]">{{stageMark.name}}</span>
  </div>
  <div id="ece-corporate-icon" class="chrome-ece-link">
    <button kendoButton [look]="'flat'" (click)="onIconClick()" [imageUrl]="logoBtnUrl">
    </button>
  </div>
  <div class="user pull-right">
    <kendo-avatar
      width="36px"
      height="36px"
      shape="circle"
      [initials]="initials"
      [imageSrc]="imageSrc"
    ></kendo-avatar>
    <kendo-dropdownbutton [data]="data" fillMode="flat">
      <div  [title]="person.email || ''">{{ person.displayName }}</div>
      <ng-template kendoDropDownButtonItemTemplate let-dataItem>
        {{ dataItem.displayName | i18n }}
      </ng-template>
    </kendo-dropdownbutton>
  </div>
</div>
